export default "__VITE_ASSET__dd4492e8__"